<!--

This component displays data from a user editable department module note.
This is only to display "Text" style notes.

To use this, you need to get the note id from the admin page for the note
you want to display (it's at the top of the note editing screen).

Usage is as follows: 

<note-text note-id="1"></note-text>

-->

<template>
  <div ref="notedata">
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      noteData: ""
    }
  },
  props: ['noteId'],
  mounted: function() {
    this.getData()
  },
  methods: {
    getData: function() {
      //component reference
      let local = this

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/note/' + this.noteId,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (response) {
          //create an editor for each note
          local.noteData = response.data.note
          let noteRegion = local.$refs.notedata
          noteRegion.innerHTML = response.data.note
        })
        .catch(function (error) {
          console.log("error geting module data: ", error)
        });
    }
  }
}
</script>

<style>
</style>
